
import {Link, useLocation, useParams} from "react-router-dom"

const CardMenu = (props) => {
    const {id, id2} = useParams()
    const location = useLocation()
    let currentPath = props.active ? props.active : location.pathname.replace(id, '')
    currentPath = currentPath.replace(id2, '')


    return <div className="card-menu">
        <div className="card-menu-inner">
            {props && props.items && props.items.length > 0 && <div>
                {props.items.map((item, index) => {
                    let activePath = item.path.replace(':id', '')
                    activePath = activePath.replace(':id2', '')
                    let active = activePath === currentPath


                    if(!active && item.paths){
                        item.paths.map((path) => {
                            let inPath = path.replace(':id', '')
                            inPath = inPath.replace(':id2', '')
                            active =  inPath === currentPath
                        })
                    }


                    return <Link key={`Menu_${id}_${index}`} data-active={active} to={
                        item.path.replace(':id', id).replace(':id2', id2)
                    }>
                        {item.icon} {item.label}
                    </Link>
                })}
            </div>}
        </div>
    </div>
}

export default CardMenu;